import AuthCopyright from "../../auth/components/AuthCopyright";
import AreaBox from "../../auth/components/AreaBox";
import HeaderNav from "../../auth/components/HeaderNav";
import HeroArea from "../../auth/components/HeroArea";
import MainBox from "../../auth/components/MainBox";
import MainBoxTitleText from "../../auth/components/MainBoxTitleText";
import RegisterUserDataForm from "./components/RegisterUserDataForm";

export default function RegisterUserData() {
  return (
    <>
      <HeaderNav />
      <AreaBox>
        <HeroArea />
        <MainBoxTitleText text="ようこそ！まずは、あなたの情報を登録してください。" />
        <MainBox>
          <RegisterUserDataForm />
        </MainBox>
        <AuthCopyright />
      </AreaBox>
    </>
  )
}
